<template>
	<div>
		<section class="section-title-page container-fluid" style="background-image: url('/img/bg_tramite.jpg')">
			<div class="container">
				<div class="wrapper">
					<h1>Servicios <small style="font-weight: 300">a tu disposición</small></h1>
					<span>
						Volver <i class="fa fa-angle-right mx-1"></i>
						<a href="/Servicios/">Servicios</a>
					</span>
				</div>
			</div>
		</section>
		<section class="section-page container-fluid">
			<div class="container">
				<div class="section-info">
					<p class="m-0">
						<i class="fa-solid fa-circle mr-2"></i>Este apartado permite consultar estadísticas por género de los colegiados del
						<strong>CMVDSM</strong>
					</p>
				</div>
			</div>
			<div class="container service-selected">
				<div class="col statistics">
					<div class="description">
						<div class="selects">
							<div class="select">
								<h6 class="mb-2">Género</h6>
								<select id="selectGender" class="form-control" @change="updateGender($event.target.value)">
									<option selected value="0">TODOS</option>
									<option v-for="(value, k) in Sexs" :key="k" :value="value.id">
										{{ value.sexo }}
									</option>
								</select>
							</div>
							<div class="select">
								<h6 class="mb-2">Provincia</h6>
								<select id="selectProvince" class="form-control" @change="updateProvince($event.target.value)">
									<option selected value="0">TODOS</option>
									<option v-for="(value, k) in Province" :key="k" :value="value.id">
										{{ value.provincia }}
									</option>
								</select>
							</div>
						</div>
						<div class="text">
							<p class="m-0">Al seleccionar cualquier opción, los gráficos muestran la cantidad de colegiados hombres o mujeres en cada año, según el género seleccionado.</p>
						</div>
					</div>
					<div class="power-bi">
						<div class="col-md-12 p-0">
							<div class="view">
								<p v-show="!Estadisticas.length" ref="msgChart">¡Seleccione una opción!</p>
								<canvas ref="myChart" v-if="Estadisticas.length"></canvas>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Chart from 'chart.js'

export default {
	name: 'estadisticas_colegiados',
	computed: {
		...mapState(['empresa'])
	},
	mounted() {
		this.getSexs()
		this.getProvinces()
		this.fetchData(0, 0) // Llamada inicial con valores por defecto
	},
	data() {
		return {
			Estadisticas: [],
			chartInstance: null,
			selectedGender: 0,
			selectedProvince: 0,
			Sexs: [],
			Province: [],
			loading: false
		}
	},
	methods: {
		...mapMutations(['setLoading']),
		getSexs() {
			this.setLoading(true)
			this.$http
				.get('ws_collegiate/list_sexes')
				.then((res) => {
					this.Sexs = res.data.Sexos
				})
				.finally(() => {
					this.setLoading(false)
				})
		},
		getProvinces() {
			this.setLoading(true)
			this.$http
				.get('ws_main/provinces')
				.then((res) => {
					this.Province = res.data.Provincias
				})
				.finally(() => {
					this.setLoading(false)
				})
		},
		updateGender(gender) {
			this.selectedGender = gender
			this.fetchData(this.selectedGender, this.selectedProvince)
		},
		updateProvince(province) {
			this.selectedProvince = province
			this.fetchData(this.selectedGender, this.selectedProvince)
		},
		async fetchData(gender, province) {
			this.loading = true
			try {
				const res = await this.$http.get(`ws_collegiate/statistics?sexo=${gender}&provincia=${province}`)
				this.Estadisticas = res.data.Statistics
				if (this.Estadisticas.length > 0) {
					this.$nextTick(() => {
						this.renderChart()
					})
				} else {
					this.Estadisticas
					this.$refs.msgChart.innerHTML = '<h5><i class="fa fa-sad-cry"></i> <strong>Lo sentimos</strong>, no existen registros.</h5>'
				}
			} finally {
				this.loading = false
			}
		},
		renderChart() {
			const ctx = this.$refs.myChart.getContext('2d')
			if (this.chartInstance) {
				this.chartInstance.destroy()
			}

			const labels = this.Estadisticas.map((item) => item.anio)
			const values = this.Estadisticas.map((item) => item.cantidad)

			this.chartInstance = new Chart(ctx, {
				type: 'bar',
				data: {
					labels,
					datasets: [
						{
							label: 'Cantidad de Colegiados',
							data: values,
							backgroundColor: '#73000A',
							borderColor: '#fff',
							borderWidth: 1
						}
					]
				},
				options: {
					responsive: true,
					scales: {
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									suggestedMin: 0,
									suggestedMax: Math.max(...values) + 1,
									stepSize: 0.5
								}
							}
						]
					}
				}
			})
		}
	}
}
</script>

<style>
.selected {
	background-color: #73000a !important;
	color: #fff !important;
}
</style>
